// WO-20: how sealed product types (product_types table, WO-10) are grouped in navigation and filters.
// Unknown types (a new game's types, WO-14) still show: each becomes its own group named by its type_name.

export const SEALED_GROUPS = [
  { key: 'booster-boxes', label: 'Booster Boxes', art: 'box', types: ['booster_box', 'half_booster_box'] },
  { key: 'elite-trainer-boxes', label: 'Elite Trainer Boxes', art: 'etb', types: ['elite_trainer_box'] },
  { key: 'booster-bundles', label: 'Booster Bundles', art: 'bundle', types: ['booster_bundle'] },
  { key: 'packs', label: 'Packs & Blisters', art: 'pack', types: ['booster_pack', 'sleeved_booster', 'blister'] },
  { key: 'collections', label: 'Collections', art: 'collection', types: ['collection_box', 'premium_collection', 'ultra_premium_collection'] },
  { key: 'tins', label: 'Tins', art: 'tin', types: ['tin', 'mini_tin'] },
  { key: 'decks', label: 'Decks & Kits', art: 'deck', types: ['build_and_battle', 'build_and_battle_stadium', 'theme_deck', 'starter_deck', 'battle_deck', 'trainer_kit', 'world_championship_deck'] },
  { key: 'cases', label: 'Cases', art: 'case', types: ['booster_case', 'etb_case', 'booster_bundle_case', 'sleeved_booster_case', 'case'] },
  { key: 'other', label: 'Other Sealed', art: 'box', types: ['other_sealed'] },
];

const TYPE_TO_GROUP = {};
SEALED_GROUPS.forEach((g) => g.types.forEach((t) => { TYPE_TO_GROUP[t] = g; }));

export function groupOfType(productType, typeName = '') {
  return TYPE_TO_GROUP[productType] || { key: `t-${productType}`, label: typeName || productType, art: 'box', types: [productType] };
}

export function groupByKey(key) {
  return SEALED_GROUPS.find((g) => g.key === key) || (key && key.startsWith('t-')
    ? { key, label: key.slice(2).replace(/_/g, ' '), art: 'box', types: [key.slice(2)] }
    : null);
}

// Facet counts [{product_type, type_name, count}] -> groups with counts, in navigation order, empty groups dropped.
export function groupsFromFacets(facets = []) {
  const byKey = new Map();
  facets.forEach((f) => {
    const g = groupOfType(f.product_type, f.type_name);
    const cur = byKey.get(g.key) || { ...g, count: 0 };
    cur.count += f.count || 0;
    byKey.set(g.key, cur);
  });
  const order = SEALED_GROUPS.map((g) => g.key);
  return [...byKey.values()].sort((a, b) => {
    const ia = order.indexOf(a.key); const ib = order.indexOf(b.key);
    return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib) || a.label.localeCompare(b.label);
  });
}

// Words that make a search query "about" sealed product (sealed results are ranked first for these).
export const SEALED_QUERY = /\b(etbs?|elite trainer|booster|boxe?s?|bundles?|tins?|blisters?|collections?|packs?|cases?|displays?|sealed|upc|spc|build ?& ?battle|decks?)\b/i;

export const EXCLUSIVE_LABELS = {
  pc: 'Pokémon Center', target: 'Target', costco: 'Costco', 'sams-club': "Sam's Club", walmart: 'Walmart',
  'dollar-general': 'Dollar General', 'best-buy': 'Best Buy', gamestop: 'GameStop',
};
